import { Component, Input } from '@angular/core';

export type TimelineStepStatus = 'completed' | 'current' | 'pending';

export interface TimelineStep {
  label: string;
  description?: string;
  status: TimelineStepStatus;
}

/**
 * PLAN-Pitts-Salud-Flota-FRONT.md §8/§6.3 — timeline/stepper reusable, número
 * variable de pasos. `StepsModule` de PrimeNG está exportado pero solo se
 * usa en auth/register (navegación entre pasos de un form, no una línea de
 * tiempo de estado); Repuestos se hizo un `.timeline` a mano en SCSS local.
 * Este componente es de solo lectura — no navega, solo muestra progreso.
 */
@Component({
  selector: 'app-timeline',
  standalone: false,
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.scss',
})
export class TimelineComponent {
  @Input() steps: TimelineStep[] = [];
}
